module.exports = __webpack_public_path__ + "img/massages-blue.272cd08d.png";